import { useEffect, useState } from 'react';
import AdminLayout from '../AdminLayout';
import {
  getOurWorkPhotosAdmin, addOurWorkPhoto, deleteOurWorkPhoto,
  getOurWorkVideosAdmin, addOurWorkVideo, deleteOurWorkVideo,
  getTutorialVideosAdmin, addTutorialVideo, deleteTutorialVideo,
} from '../../services/adminService';
import { uploadToCloudinary } from '../../utils/uploadToCloudinary';

function PhotosTab() {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [title, setTitle] = useState('');
  const [imgUrl, setImgUrl] = useState('');

  const load = () => getOurWorkPhotosAdmin().then(d => { setPhotos(d); setLoading(false); });
  useEffect(() => { load(); }, []);

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try { const url = await uploadToCloudinary(file); setImgUrl(url); }
    catch { alert('Upload failed'); }
    finally { setUploading(false); }
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!imgUrl || !title) return;
    await addOurWorkPhoto({ Image: imgUrl, Title: title, order: photos.length });
    setImgUrl(''); setTitle('');
    load();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Remove?')) return;
    await deleteOurWorkPhoto(id);
    setPhotos(p => p.filter(x => x.id !== id));
  };

  return (
    <div>
      <form className="admin-form" onSubmit={handleAdd} style={{ maxWidth: 500, marginBottom: 24 }}>
        <div><label>Photo</label>
          <label className="upload-box">
            <input type="file" accept="image/*" onChange={handleFile} />
            {uploading ? <p>Uploading…</p> : imgUrl ? <img src={imgUrl} alt="" style={{ maxHeight: 80 }} /> : <p>Click to upload</p>}
          </label>
        </div>
        <div><label>Title</label><input value={title} onChange={e => setTitle(e.target.value)} placeholder="Photo title" required /></div>
        <div><button className="a-btn a-btn-primary" type="submit" disabled={!imgUrl || !title}>Add Photo</button></div>
      </form>
      {loading ? <div className="admin-spinner">Loading…</div> : (
        <div className="admin-gallery-grid">
          {photos.map(p => (
            <div key={p.id} className="admin-gallery-item">
              <img src={p.Image} alt={p.Title} />
              <div className="delete-overlay"><button onClick={() => handleDelete(p.id)}>Remove</button></div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function VideosTab({ getFn, addFn, deleteFn, fields }) {
  const [videos, setVideos] = useState([]);
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(true);

  const load = () => getFn().then(d => { setVideos(d); setLoading(false); });
  useEffect(() => { load(); }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    await addFn({ ...form, order: videos.length });
    setForm({});
    load();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Remove?')) return;
    await deleteFn(id);
    setVideos(v => v.filter(x => x.id !== id));
  };

  return (
    <div>
      <form className="admin-form" onSubmit={handleAdd} style={{ maxWidth: 500, marginBottom: 24 }}>
        {fields.map(f => (
          <div key={f.key}>
            <label>{f.label}</label>
            <input value={form[f.key] || ''} onChange={e => setForm(p => ({ ...p, [f.key]: e.target.value }))} placeholder={f.placeholder} required />
          </div>
        ))}
        <div><button className="a-btn a-btn-primary" type="submit">Add Video</button></div>
      </form>
      {loading ? <div className="admin-spinner">Loading…</div> : (
        videos.length === 0 ? <div className="admin-empty">No videos yet</div> : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {videos.map(v => (
              <div key={v.id} className="admin-list-item">
                <div className="admin-list-item-content" style={{ fontSize: 14 }}>
                  {v.Title && <strong>{v.Title}</strong>}
                  {v.title && <strong>{v.title}</strong>}
                  <div style={{ fontSize: 12, color: 'var(--a-text-muted)', wordBreak: 'break-all' }}>{v.Link || v.link}</div>
                </div>
                <div className="admin-list-item-actions">
                  <button className="a-btn a-btn-sm a-btn-danger" onClick={() => handleDelete(v.id)}>Remove</button>
                </div>
              </div>
            ))}
          </div>
        )
      )}
    </div>
  );
}

const TABS = ['Our Work Photos', 'Our Work Videos', 'Tutorial Videos'];

export default function AdminOurWork() {
  const [tab, setTab] = useState(0);
  return (
    <AdminLayout title="Our Work & Tutorials">
      <div className="admin-tabs">
        {TABS.map((t, i) => (
          <button key={t} className={`admin-tab${tab === i ? ' active' : ''}`} onClick={() => setTab(i)}>{t}</button>
        ))}
      </div>
      <div className="admin-section">
        <div className="admin-section-header"><h2>{TABS[tab]}</h2></div>
        <div className="admin-section-body">
          {tab === 0 && <PhotosTab />}
          {tab === 1 && <VideosTab getFn={getOurWorkVideosAdmin} addFn={addOurWorkVideo} deleteFn={deleteOurWorkVideo}
            fields={[{ key: 'Link', label: 'YouTube URL', placeholder: 'https://youtube.com/watch?v=...' }]} />}
          {tab === 2 && <VideosTab getFn={getTutorialVideosAdmin} addFn={addTutorialVideo} deleteFn={deleteTutorialVideo}
            fields={[
              { key: 'title', label: 'Title', placeholder: 'Tutorial title' },
              { key: 'link', label: 'YouTube URL', placeholder: 'https://youtube.com/...' },
            ]} />}
        </div>
      </div>
    </AdminLayout>
  );
}
